exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-45[data-v-38dc4c8a]{margin-top:-45px}.mt-56[data-v-38dc4c8a]{margin-top:-56px}.title-tournament[data-v-38dc4c8a]{text-shadow:1px 1px #000;color:#62c6c5}.tag-inscription[data-v-38dc4c8a]{background-color:#6273b7}.tag-end[data-v-38dc4c8a]{background-color:red}.tag-completed[data-v-38dc4c8a]{background-color:#ffc107}", ""]);

// exports
